module.exports = __webpack_public_path__ + "img/bevfam_reward_btn.a4c98bef.png";